module.exports = __webpack_public_path__ + "img/46.e8319cd.jpg";